/* eslint-disable max-len */
import React from 'react'
import { Modal, ModalBody } from 'reactstrap'
import { Link } from 'react-router-dom'

const PurchaseSuccessModal = ({ show, orderNo, hasItemWithAckRequired, to, toggle }) => (
  <Modal isOpen={show} toggle={toggle} centered className="edv2-purchase-success-modal">
    <ModalBody className="edv2-modal">
      <p className="edv2-modal__title">Your purchase has been placed.</p>
      <p className="edv2-modal__body">
        Please make payment using QR code found under MY PURCHASE to confirm your order.
        {hasItemWithAckRequired && (
          <>
            <br />
            If you see &quot;Payment to be made after closing date&quot; in the order, you must wait until
            the closing date to make payment.
          </>
        )}
      </p>
      <Link
        to={to || `/event/purchase-detail?ref=${orderNo}`}
        className="edv2-button edv2-button--solid"
        style={{ height: '35px' }}
      >
        Confirm your order
      </Link>
    </ModalBody>
  </Modal>
)

export default PurchaseSuccessModal
